import api from "@/lib/api";

// FAZ 2C — Tek canonical kaynak: GET /api/inventory/stock-availability (FAZ 2B).
// Yeni hesap motoru YOK; bu yardımcı yalnız endpoint response'unu taşır/toplar.
const num = (v) => Number(v || 0);

export async function fetchAvailability({ productIds, warehouseId } = {}) {
  const params = {};
  if (productIds && productIds.length) params.product_ids = productIds.join(",");
  if (warehouseId) params.warehouse_id = warehouseId;
  const { data } = await api.get("/inventory/stock-availability", { params });
  return Array.isArray(data) ? data : [];
}

// Ürün toplamları: physical / reserved (fiziksel+yoldan) / incoming / available_total
export function aggregateForProduct(rows, productId) {
  const pr = (rows || []).filter((r) => r.product_id === productId);
  const sum = (f) => pr.reduce((s, r) => s + num(r[f]), 0);
  return {
    physical: sum("physical"),
    reserved: sum("reserved_physical") + sum("reserved_incoming"),
    incoming: sum("incoming"),
    available: sum("available_total"),
    rows: pr,
  };
}

// Depo grupları. Yolda (incoming) depo-agnostiktir: yalnız warehouse_id===""
// grubunda anlamlıdır; depo gruplarına DAĞITILMAZ.
export function groupByWarehouse(rows) {
  const map = {};
  for (const r of rows || []) {
    const k = r.warehouse_id || "";
    if (!map[k]) {
      map[k] = { warehouse_id: k, physical: 0, reserved: 0, incoming: 0,
                 availablePhysical: 0, availableIncoming: 0, rows: [] };
    }
    const g = map[k];
    g.physical += num(r.physical);
    g.reserved += num(r.reserved_physical) + num(r.reserved_incoming);
    g.incoming += num(r.incoming);
    g.availablePhysical += num(r.available_physical);
    g.availableIncoming += num(r.available_incoming);
    g.rows.push(r);
  }
  return map;
}

// Varyant toplamı (tüm depolar + depo-agnostik yolda satırı dahil)
export function aggregateForVariant(rows, variantId) {
  const vr = (rows || []).filter((r) => (r.variant_id || "") === (variantId || ""));
  const sum = (f) => vr.reduce((s, r) => s + num(r[f]), 0);
  return {
    physical: sum("physical"),
    reserved: sum("reserved_physical") + sum("reserved_incoming"),
    incoming: sum("incoming"),
    available: sum("available_physical") + sum("available_incoming"),
  };
}
